module.exports = __webpack_public_path__ + "img/open-answer.e9e47775.svg";